import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { getSiteConfigs, SiteConfigs, siteDefaultConfigs } from '../api/configs.api';
import { useAuth } from './auth-context';

interface SiteConfigsContextType extends SiteConfigs {

}

const SiteConfigsContext = createContext<SiteConfigsContextType | null>(null);

interface SiteConfigsProviderProps {
    children: ReactNode;
}

export const SiteConfigProvider = ({ children }: SiteConfigsProviderProps) => {
    const { tokens: { reactToken } } = useAuth();
    const [ siteConfigs, setSiteConfigs ] = useState<SiteConfigs>({
        name: '',
        footer: '',
        logo: '',
    });

    useEffect(() => {
        if (!reactToken) {
            return;
        }

        getSiteConfigs()
        .then(response => {
            setSiteConfigs(response);
        })
        .catch(e => {
            console.error(e);
            setSiteConfigs(siteDefaultConfigs);
        });
    }, [ reactToken ]);

    return (
        <SiteConfigsContext.Provider value={siteConfigs}>
            {children}
        </SiteConfigsContext.Provider>
    );
};

export const useSiteConfig = () => {
    const context = useContext(SiteConfigsContext);
    if (!context) {
        throw new Error('useSiteConfig must be used within a SiteConfigProvider');
    }
    return context;
};